import countries from 'i18n-iso-countries';
import enLocale from 'i18n-iso-countries/langs/en.json';
import ruLocale from 'i18n-iso-countries/langs/ru.json';
import frLocale from 'i18n-iso-countries/langs/fr.json';
import deLocale from 'i18n-iso-countries/langs/de.json';
import nlLocale from 'i18n-iso-countries/langs/nl.json';
import type { Language } from '../contexts/TranslationContext';

countries.registerLocale(enLocale);
countries.registerLocale(ruLocale);
countries.registerLocale(frLocale);
countries.registerLocale(deLocale);
countries.registerLocale(nlLocale);

const PRIORITY_COUNTRY_CODES = ['BE', 'FR', 'DE', 'NL'] as const;

export type RegistrationCountry = {
    value: string;
    label: string;
};

export const getRegistrationCountries = (locale: Language): RegistrationCountry[] => {
    const localizedByCode = countries.getNames(locale) as Record<string, string>;

    const priorityCountries = PRIORITY_COUNTRY_CODES.map((code) => ({
        value: code,
        label: localizedByCode[code],
    }));
    const restCountries = Object.entries(localizedByCode).map(([code, label]) => ({ value: code, label }));

    return [...priorityCountries, ...restCountries];
};
